import { getCompressedImageUrl } from 'components/images/responsive-image/utils'

// Keep the existing poster rendition identical for video and preload requests.
const POSTER_WIDTH = 582
const POSTER_HEIGHT = 774

const getVideoPosterUrl = (poster, desktopHero = false) =>
  poster
    ? getCompressedImageUrl(
        poster,
        desktopHero ? 1920 : POSTER_WIDTH,
        desktopHero ? 1080 : POSTER_HEIGHT,
      )
    : ''

export default getVideoPosterUrl
